<template>
  <div class="QRCode">

    <!-- 选择区 -->
    <div class="selectionArea">
      <div class="item">
        <span class="title">来源</span>
        <el-select v-model="parameter.source_type" placeholder="请选择">
          <el-option
            v-for="item in qRCodeType"
            :key="item.id"
            :label="item.value"
            :value="item.id"
          />
        </el-select>
      </div>

      <div class="item">
        <span class="title">状态</span>
        <el-select v-model="parameter.status" placeholder="请选择">
          <el-option
            v-for="item in states"
            :key="item.id"
            :label="item.value"
            :value="item.id"
          />
        </el-select>
      </div>

      <div class="item">
        <span class="title">微信号</span>
        <el-input v-model="parameter.phone_vx_account" />
      </div>

      <div class="item">
        <span class="title">二维码编号</span>
        <el-input v-model="parameter.code_no" />
      </div>

      <div class="item">
        <span class="title">管理员id</span>
        <el-input v-model="parameter.admin_id" />
      </div>

      <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      <el-button type="info" icon="el-icon-refresh" @click="reset">重置</el-button>
      <el-button type="success" icon="el-icon-s-help" @click="dialogVisible = true">创建</el-button>
    </div>

    <!-- 主体区 -->
    <div>
      <el-table
        v-loading="loading"
        :data="tableData.list"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="source_text"
          label="来源"
          width="180"
          align="center"
        />
        <el-table-column
          prop="admin_name"
          label="管理员名称"
          width="180"
          align="center"
        />
        <el-table-column
          prop="status_text"
          label="状态"
          width="180"
          align="center"
        >
          <template slot-scope="scope">
            <i v-if="scope.row.status == 1" class="el-icon-warning defaultrse" />
            <i v-if="scope.row.status == 2" class="el-icon-warning defaultr" />
            <i v-if="scope.row.status == 3" class="el-icon-success defaultr" />
            <i v-if="scope.row.status == 4" class="el-icon-circle-close stopew" />
            {{ scope.row.status_text }}
          </template>
        </el-table-column>
        <el-table-column
          prop="phone_vx_account"
          label="微信号"
          width="180"
          align="center"
        />
        <el-table-column
          prop="code_no"
          label="二维码编号"
          width="180"
          align="center"
        />
        <el-table-column
          prop="process_time_text"
          label="处理时间"
          width="180"
          align="center"
        />
        <el-table-column
          prop="err_info"
          label="失败原因"
          width="180"
          align="center"
        />
        <el-table-column
          prop="content_type_text"
          label="推送类型"
          width="180"
          align="center"
        />
        <el-table-column
          prop="admin_name"
          label="管理员"
          width="180"
          align="center"
        />
        <el-table-column
          prop="send_text"
          label="发送时间"
          width="180"
          align="center"
        />
        <el-table-column
          prop="update_at_text"
          label="修改时间"
          width="180"
          align="center"
        />
        <el-table-column
          prop="address"
          label="操作"
          min-width="180"
          align="center"
        >
          <template scope="scope">
            <el-button type="warning" size="mini" @click="(check = scope.row),(dialogVisible = true)">修改</el-button>
            <el-button type="danger" size="mini" @click="myDelete(scope.row)">删除</el-button>
          </template>

        </el-table-column>
      </el-table>
    </div>
    <pagination-right
      :total="tableData.total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <el-dialog
      :title="check ? '更新' : '创建'"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <QRCodeInformation v-if="dialogVisible" :check="check" @determine="determine" @cancel="dialogVisible = false" />
    </el-dialog>
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import QRCodeInformation from './components/qRCodeInformation.vue'
import { qRCodeList, createQRCode, qRCodeModification, qRCodeDeletion } from '@/api/mobilePhoneScanningCode.js'
export default {
  name: 'QRCodeList',
  components: {
    PaginationRight,
    QRCodeInformation
  },
  data() {
    return {
      parameter: {
        source_type: null, // 来源
        status: null, // 状态
        phone_vx_account: null, // 微信号
        code_no: null, // 二维码编号
        admin_id: null, // 管理员
        page: 1,
        page_size: 10
      },
      loading: false,
      qRCodeType: [{ id: 1, value: '公众号扫码登录' }, { id: 2, value: '鉴权' }, { id: 3, value: '群发' }, { id: 4, value: '其他' }],
      states: [{ id: 1, value: '待发送客户端处理' }, { id: 2, value: '已经发送' }, { id: 3, value: '已经处理(成功)' }, { id: 4, value: '处理失败' }],
      tableData: {
        total: null
      },
      dialogVisible: false,
      check: undefined
    }
  },
  created() {
    this.getDatas()
  },
  methods: {
    async getDatas() {
      this.loading = true
      const data = await qRCodeList(this.parameter)
      this.tableData = data.data
      this.loading = false
    },
    fetchPageSize(e) {
      this.parameter.page_size = e
      this.getDatas()
    },

    fetchCurrentPage(e) {
      this.parameter.page = e
      this.getDatas()
    },

    handleClose() {
      this.check = undefined
      this.dialogVisible = false
    },

    // 删除
    async myDelete(row) {
      await qRCodeDeletion({ id: row.id })
      this.$message({
        message: '删除成功',
        type: 'success'
      })
      this.getDatas()
    },

    // 提交
    async determine(obj) {
      const bool = this.judgeParameter(obj)
      if (!bool) {
        return
      }
      this.check ? await qRCodeModification({ ...obj, id: this.check.id }) : await createQRCode(obj)
      this.$message({
        message: this.check ? '修改成功' : '创建成功',
        type: 'success'
      })
      this.check = undefined
      this.dialogVisible = false
      this.getDatas()
    },

    // 判断参数
    judgeParameter(obj) {
      console.log('obj', obj)
      let text = null
      if (!obj.source_type) {
        text = '请选择二维码类型'
      } else if (!obj.phone_vx_account) {
        text = '请选择手机编号'
      } else if (!obj.content_type) {
        text = '请选择推送类型'
      } else if (obj.source_type === 2) {
        if (obj.content/* [0] */.account_name === null) {
          text = '请填写公众号名称'
        }
      } else if (!obj.content.src /* || !obj.content.length */) {
        text = '请上传二维码'
      }

      text && this.$message({
        message: text,
        type: 'warning'
      })

      return !text
    },

    // 搜索
    search() {
      this.parameter.page = 1
      this.getDatas()
    },

    // 重置
    reset() {
      this.parameter = {
        source_type: null, // 来源
        state: null, // 状态
        phone_vx_account: null, // 微信号
        code_no: null, // 二维码编号
        admin_id: null, // 管理员
        page: 1,
        page_size: 10
      }
      this.getDatas()
    }
  }
}
</script>

<style scoped>
.QRCode{
   width: 95%;
   margin: 0 auto;
   margin-top: 30px;
}

.selectionArea{
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 30px;
      gap:10px;
}

.item{
  display: flex;
  align-items: center;
}

.title{
       white-space: pre;
       display: inline-block;
       margin-right: 7px;
}
.defaultr{
  color: #67C23A;
}
.defaultrse{
  color: #E6A23C;
}
.stopew{
  color: red;
}
@media (max-width: 768px) {
  .selectionArea .item{
    width:100%;
  }
}

</style>
